<template>
  <div class="layout my-contacts">
    <div class="tab_nav">
      <div class="nav_item" :class="{is_active:tabName==item.name}" @click="tabChange(item)" v-for="(item,index) in navList" :key="index">{{item.title}}</div>
    </div>
    <div class="tab_content">
      <div class="list_wrap">
        <List v-model="loading" :finished="finished" @load="loadMore"> 
          <div class="item" v-for="(item,index) in list" :key="index" @click="msgClick(item)">
            <div class="item_info">
              <img  :src="item.senderAvatarUrl" >
              <!-- <p class="name van-ellipsis">{{item.senderFullName}}</p> -->
              <span v-if="item.sendUserType==1" class=" zb">Organzier</span>
              <span v-else-if="item.sendUserType==0" class=" xt">System</span>
              <p class="hint" v-if="item.sendUserType>1">{{item.title}}</p>
              <p class="time">{{item.dataTime}}</p>
            </div>
            <p class="msg_content">{{item.content}}</p>
            <div class="msg_source " v-if="item.introduction" @click="goToIntorduction(item)">
              <p class="van-ellipsis" >Source：{{item.introduction}}</p>
            </div>
            <div v-if="!item.hasRead" class="unread_tag">Unread</div>
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </List>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
export default {
  name: "my-contacts",
  components:{
    List
  },
  data() {
    return {
      tabName:'all',
      navList:[
        {title:'All',name:'all'},
        {title:'Unread',name:'unread'},
        {title:'Organzier',name:'host'},
        {title:'System',name:'system'}
      ],
      loading: false,   //消息列表加载状态
      finished: false,  //消息列表是否完成状态
      list: [],    //消息列表
      pageIndex: 0,
      pageSize:20,
      isTab:false,
      notificationMessageQuery:{},
    } 
  },
  async created(){
    this.$store.commit('setExhibitionId',this.$route.params.id);
    if(!this.userInfo){
      await this.$Myapollo.getUserInfo(this);
    }
    if(!this.exhibitionInfo){
      await this.$Myapollo.getExhibitionInfo(this,this.$route.params.id,this.userInfo.userId);
    }
    this.$Myapollo.addExhibitionView();
    this.tabName=this.myMessageHead
  },
  mounted(){
  },
  computed: {
    ...mapGetters({
      myMessageHead:'getMyMessageHead',
      userInfo:'getUserInfo',
      exhibitionId:"getExhibitionId",
      exhibitionInfo:"getExhibitionInfo"
    }),

  },
  methods:{
    ...mapActions({
      LinkToSupply:'linkTo/LinkToSupply',
      LinkToHotTopDetails:'linkTo/LinkToHotTopDetails',
      LinkExInvitation:'linkTo/LinkExInvitation',
      LinkProduct:'linkTo/LinkProduct',
      msgRead:'my/msgRead',
      graphqlPost: "en/graphqlPostByZXS",
    }),
    tabChange(item){
      if(item.name==this.tabName){
        return
      } 
      this.$Myapollo.addExhibitionView();
      this.tabName=item.name;
      this.$store.commit('setMyMessageHead',item.name);
      this.list=[];
      this.pageIndex=1;
      this.finished=false;
      this.isTab=true;
      // this.getList();
      this.getListNew();
    },
    // 20210419 新的获取信息
    async getListNew() {
       if(this.tabName === "all") {
        // 全部消息
        let query = `
          query {
            notificationMessageQuery{
              queryByReceiver2(
                query: { 
                   page: ${this.pageIndex}, size: ${this.pageSize},
                   where: {
                    or: {
                      and_XiTongGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 0 },
                        equal_referenceType: { n: "referenceType" , v: 200},
                        equal_langVersion: { n: "langVersion", v: "en" }
                      },
                      and_ZhuBanGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 1 },
                        equal_referenceType: { n: "referenceType" , v: 200},
                        equal_langVersion: { n: "langVersion", v: "en" },
                        equal_exhibitionId: {
                          n: "exhibitionId",
                          v: "${this.exhibitionId}"
                        }
                      },
                      and_XiTongXiaoXi: {
                        equal_sendUserType: { n: "sendUserType", v: 0 },
                        notequal_referenceType: { n: "referenceType" , v: 200},
                        equal_langVersion: { n: "langVersion", v: "en" },
                        equal_exhibitionId: {
                          n: "exhibitionId",
                          v: "${this.exhibitionId}"
                        }
                      }
                    }
                  }
                  order: [
                    { n: "messageState", v: 1 }
                    { n: "readAt", v: 0 }
                    { n: "receiveUserType", v: 1 }
                    { n: "createAt", v: 0 }
                  ]
                }
                receiverId: "${this.userInfo.userId}"
                receiveUserTypes:[3, 4]
              ){
                hasNextPage
                indexFrom
                pageIndex
                pageSize
                items{
                  content
                  createAt
                  id
                  introduction
                  receiverId
                  messageState
                  publishAt
                  hasRead(receiverId: "${this.userInfo.userId}")
                  senderFullName
                  senderAvatarUrl
                  senderId
                  sendUserType
                  title
                  referenceId
                  referenceType
                  langVersion
                }
              }
            }
          }
        `;
        this.opt = {
          query: query,
          variables: {},
        };
      } else if(this.tabName == 'unread') {
        // 未读消息
        let query = `
          query {
            notificationMessageQuery{
              queryByReceiver2(
                query: { 
                  page: ${this.pageIndex}, size: ${this.pageSize},
                  where: {
                    or: {
                      and_XiTongGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 0 },
                        equal_referenceType: { n: "referenceType" , v: 200 },
                        equal_langVersion: { n: "langVersion", v: "en" }
                      },
                      and_ZhuBanGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 1 },
                        equal_referenceType: { n: "referenceType" , v: 200 },
                        equal_langVersion: { n: "langVersion", v: "en" },
                        equal_exhibitionId: {
                          n: "exhibitionId",
                          v: "${this.exhibitionId}"
                        }
                      },
                      and_XiTongXiaoXi: {
                        equal_sendUserType: { n: "sendUserType", v: 0 },
                        notequal_referenceType: { n: "referenceType" , v: 200},
                        equal_langVersion: { n: "langVersion", v: "en" },
                        equal_exhibitionId: {
                          n: "exhibitionId",
                          v: "${this.exhibitionId}"
                        }
                      }
                    },
                    equal_messageState: { n: "messageState", v: 0 }
                  }
                  order: [
                    { n: "messageState", v: 1 }
                    { n: "readAt", v: 0 }
                    { n: "receiveUserType", v: 1 }
                    { n: "createAt", v: 0 }
                  ]
                }
                receiverId: "${this.userInfo.userId}"
                receiveUserTypes:[3, 4]
              ){
                hasNextPage
                indexFrom
                pageIndex
                pageSize
                items{
                  content
                  createAt
                  id
                  introduction
                  receiverId
                  messageState
                  publishAt
                  hasRead(receiverId: "${this.userInfo.userId}")
                  senderFullName
                  senderAvatarUrl
                  senderId
                  sendUserType
                  title
                  referenceId
                  referenceType
                  langVersion
                }
              }
            }
          }
        `;
        this.opt = {
          query: query,
          variables: {},
        };
      } else if(this.tabName === "host") {
        // 主办消息
        let query = `
          query {
            notificationMessageQuery{
              queryByReceiver2(
                query: { 
                  page: ${this.pageIndex}, size: ${this.pageSize},
                  where: {
                    or: {
                      and_ZhuBanGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 1 }
                        equal_referenceType: { n: "referenceType" , v: 200}
                        equal_langVersion: { n: "langVersion", v: "en" }
                        equal_exhibitionId: {
                          n: "exhibitionId",
                          v: "${this.exhibitionId}"
                        }
                      }
                    }
                  }
                  order: [
                    { n: "messageState", v: 1 }
                    { n: "readAt", v: 0 }
                    { n: "receiveUserType", v: 1 }
                    { n: "createAt", v: 0 }
                  ]
                }
                receiverId: "${this.userInfo.userId}"
                receiveUserTypes:[3, 4]
              ){
                hasNextPage
                indexFrom
                pageIndex
                pageSize
                items{
                  content
                  createAt
                  id
                  introduction
                  receiverId
                  messageState
                  publishAt
                  hasRead(receiverId: "${this.userInfo.userId}")
                  senderFullName
                  senderAvatarUrl
                  senderId
                  sendUserType
                  title
                  referenceId
                  referenceType
                  langVersion
                }
              }
            }
          }
        `;
        this.opt = {
          query: query,
          variables: {},
        };
      } else {
        // 系统消息
        let query = `
          query {
            notificationMessageQuery{
              queryByReceiver2(
                query: {
                  page: ${this.pageIndex},
                  size: ${this.pageSize},
                  where: {
                    or: {
                      and_XiTongGongGao: {
                        equal_sendUserType: { n: "sendUserType", v: 0 }
                        equal_referenceType: { n: "referenceType", v: 200 }
                        equal_langVersion: { n: "langVersion", v: "en" }
                      }
                      and_XiTongXiaoXi: {
                        equal_sendUserType: { n: "sendUserType", v: 0 }
                        notEqual_referenceType: { n: "referenceType" }
                        equal_langVersion: { n: "langVersion", v: "en" }
                        equal_exhibitionId: {
                          n: "exhibitionId"
                          v: "${this.exhibitionId}"
                        }
                      }
                    }
                  }
                  order: [
                    { n: "messageState", v: 1 }
                    { n: "readAt", v: 0 }
                    { n: "receiveUserType", v: 1 }
                    { n: "createAt", v: 0 }
                  ]
                }
                receiverId: "${this.userInfo.userId}"
                receiveUserTypes:[3 ,4]
              ){
                hasNextPage
                indexFrom
                pageIndex
                pageSize
                items{
                  content
                  createAt
                  id
                  introduction
                  receiverId
                  messageState
                  publishAt
                  hasRead(receiverId: "${this.userInfo.userId}")
                  senderFullName
                  senderAvatarUrl
                  senderId
                  sendUserType
                  title
                  referenceId
                  referenceType
                  langVersion
                }
              }
            }
          }
        `;
        this.opt = {
          query: query,
          variables: {},
        };
      }
      let data = await this.graphqlPost(this.opt);
      let res = data.data.notificationMessageQuery.queryByReceiver2;
      if (this.pageIndex == 1) {
        this.list = res.items
      } else {
        this.list = [...new Set([...this.list, ...res.items])];
      }
      this.isTab = false
      this.loading = false;
      if (!res.hasNextPage) {
        this.finished = true;
      }
    },
    getList(){
     let query=gql`
      query($query:_Any!,$receiverId:String!){
        notificationMessageQuery{
          queryByReceiver2(query:$query,receiverId:$receiverId){
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items{
              content
              createAt
              id
              introduction
              receiverId
              messageState
              publishAt
              hasRead(receiverId:$receiverId)
              senderFullName
              senderAvatarUrl
              senderId  
              sendUserType
              title   
              referenceId 
              referenceType
            }               
          }
        }
      }`
      let where={}
      let order=[
        {
          n:"MessageState",
          v:1
        },
        // {
        //   n:"ReadAt",
        //   v:0
        // },
        // {
        //   n:"ReceiveUserType",
        //   v:1
        // },
        // {
        //   n:"publishAt",
        //   v:0
        // },
        {
          n:"createAt",
          v:0
        }
      ]
      // console.log(this.exhibitionId,'展会')
      // console.log(this.exhibitionInfo.exhibition.host.id,'主办')
      // console.log(this.userInfo.userId,'用户')
      
      if(this.tabName=='all'){ 
         where={
          or: {
            and_XiTongGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              equal_referenceType: { n: "referenceType",v:200 }
            },
            and_ZhuBanGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 1 },
              equal_referenceType: { n: "referenceType",v:200 },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            },
            and_XiTongXiaoXi: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              notEqual_referenceType: { n: "referenceType" },
              equal_langVersion: { n: "langVersion", v: "en" },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            }
          }
        }
      }
      //未读
      else if(this.tabName=='unread'){ 
        where={
          or: {
            and_XiTongGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              equal_referenceType: { n: "referenceType",v:200 }
            },
            and_ZhuBanGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 1 },
              equal_referenceType: { n: "referenceType",v:200 },
              equal_langVersion: { n: "langVersion", v: "en" },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            },
            and_XiTongXiaoXi: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              notEqual_referenceType: { n: "referenceType" },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            }
          },
          equal_messageState: { n: "messageState", v: 0 }
        }
      }else if(this.tabName=='host'){     //主办
      where={
          or: {
            and_ZhuBanGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 1 },
              equal_referenceType: { n: "referenceType",v:200 },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            }
          }
        }
        // where.EqualB={
        //   "n":"sendUserType",
        //   "v":1
        // },
        // where.EqualC={
        //   "n":"senderId",
        //   "v":this.exhibitionInfo.exhibition.host.id
        // }
      }else if(this.tabName=='system'){   //系统
        where={
           or: {
            and_XiTongGongGao: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              equal_referenceType: { n: "referenceType",v:200 },
            },
            and_XiTongXiaoXi: {
              equal_sendUserType: { n: "sendUserType", v: 0 },
              notEqual_referenceType: { n: "referenceType" },
              equal_langVersion: { n: "langVersion", v: "en" },
              equal_exhibitionId: {
                n: "exhibitionId",
                v: this.exhibitionId
              }
            }
          }
        }
        // where.EqualB={
        //   "n":"sendUserType",
        //   "v":0
        // }
      }
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:where,
        order:order
      }
      // console.log(opt);
      this.$apollo.addSmartQuery("notificationMessageQuery",{ 
        query:query,
        variables:{
         query:opt,
         receiverId:this.userInfo.userId
        },
        fetchPolicy: 'no-cache',    //清理缓存
        result(data){
          console.log(data,'消息')
          let res=JSON.parse(JSON.stringify(data.data.notificationMessageQuery.queryByReceiver2));
          // let res=data.data.queryProduct;
          if(res&&res.items.length){
            res.items.forEach(e => {
              e.dataTime=e.publishAt?moment(e.publishAt).format('YYYY/MM/DD'):moment(e.createAt).format('YYYY/MM/DD');
            });
          }
          if(this.pageIndex==1){
            this.list=res.items
          }else{
            this.list=[...new Set([...this.list,...res.items])];
          }
          this.isTab=false
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
    },
    loadMore(){
      if(this.finished||this.isTab) return;
      this.pageIndex+=1;
      // this.getList();
      this.getListNew();
    },
    async msgClick(item){
      if(item.hasRead){
        return 
      }
      let opt={
        messageId:item.id,
        receiverId:this.userInfo.userId
      }
      let res = await this.msgRead(opt);
      if(res.result){
        this.list.map(e=>{
          if(e.id==item.id){
            e.hasRead=true
          }
        })
      }
    },
    goToIntorduction(item){
      switch(item.referenceType){
        case 0:{
          this.LinkProduct(item.referenceId)
          break
        }
        case 1:{
          this.LinkExInvitation(item.referenceId)
          break
        }
        case 2: case 3:{
          this.LinkToSupply(item.referenceId)
          break
        }
        case 4: case 5:{
          this.LinkToHotTopDetails(item.referenceId)
          break
        }
         default:break  
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-contacts{
  background: #f2f2f2;
  padding: 0.9rem 0 0;
  .tab_nav{
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item{
      color: #666;
      width: 1.6rem;
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;
      &.is_active{
        color: #fff;
        background: #1890ff;
      }
    }
  }
  .tab_content{
    padding: 0.3rem 0.3rem 0;
    .list_wrap{
      .item{
        padding: 0.2rem 0.2rem 0.34rem;
        background: #fff;
        margin-bottom: 0.3rem;
        border-radius: 0.1rem;
        box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.1);
        position: relative;
        .unread_tag{
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;  
          width: 0.9rem;
          height: 0.3rem;
          border-radius: 0 0.1rem 0 0.1rem;
          background: rgba($color: #ff0000, $alpha: 0.1);
          color: #ff0000;
          font-size: 0.2rem;
        }
        .item_info{
          display: flex;
          align-items: center;
          height: 0.56rem;
          p{
            color: #999;
            font-size: 0.26rem;
            flex-shrink: 0;
          }
          span{
            flex-shrink: 0;
            font-size: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 0.3rem;
            width: 0.9rem;
            border-radius: 0.1rem;
            // margin-left: 0.12rem;
            &.zb{
              background: rgba($color: #ff5e00, $alpha: 0.1);
              color: #ff5e00;
            }
            &.xt{
              color: #1890ff;
              background: rgba($color: #1890ff, $alpha: 0.1);
            }
          }
          img{
            display: block;
            width: 0.56rem;
            height: 0.56rem;
            margin-right: 0.12rem;
            border-radius: 50%;
            // object-fit: cover;
          }
          .hint{
            margin-left: 0.12rem;
          }
          .name{
            color: #333;
            
            flex-shrink: 1;
          }
          .time{
            color: #666;
            margin-left: auto;
            // margin-left: 0.12rem;
            font-size: 0.22rem;
          }
        }
        p{
          font-size: 0.26rem;
        }
        .msg_content{
          color: #333;
          margin-top: 0.2rem;
        }
        .msg_source{
          margin-top: 0.3rem;
          display: flex;
          padding: 0 0.13rem;
          align-items: center;
          background: #f5f5f5;
          height: 0.5rem;
          p{
            color: #666;
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
